
  import { defineComponent } from 'vue';

  import ArrowDynamic from './ArrowDynamic.vue';

  export default defineComponent({
    name: 'DynamicIndicator',
    components: {
      ArrowDynamic,
    },
    props: {
      value: {
        type: Number,
        required: true,
      },
      oldValue: {
        type: Number,
        required: true,
      },
      postfix: {
        type: String,
        default: '',
      },
    },
    data(): {} {
      return {};
    },
    computed: {
      getAmountDifference() {
        return this.value - this.oldValue;
      },
      getAmountDifferenceAbs() {
        return Math.abs(this.getAmountDifference);
      },
      getAmountDifferenceValue() {
        const sign = this.getAmountDifference === 0 ? '' : this.getAmountDifference > 0 ? '+' : '-';
        return `${sign}${this.getAmountDifferenceAbs}`;
      },
      getTextColor() {
        if (this.getAmountDifference === 0) return 'text-gray';
        return this.getAmountDifference > 0 ? 'text-green' : 'text-red';
      },
    },
  });
